import React from "react";
import SettlementRequestsBySupplier from "../../supplierPayment/settlementRequestsBySupplier";
import TablePaymentSettlementHistory from "../../supplierPayment/tablePaymentSettlementHistory";


export default function SettlementHistory() {

    return (
        <div>

            <TablePaymentSettlementHistory />
        </div>
    );

}
